<template>
  <div>
    <box-header title="光伏电站">
      <div class="box-header-tab">
        <div @click="changeGfType('year')" class="tab-item" :class="{'active': type === 'year'}">年视图</div>
        <div @click="changeGfType('month')" class="tab-item" :class="{'active': type === 'month'}">月视图</div>
        <div @click="changeGfType('beforeTen')" class="tab-item" :class="{'active': type === 'beforeTen'}">最近十日</div>
      </div>
    </box-header>

    <div class="box" style="height: 400px;background: rgba(7,17,32,.3);">
      <box-border line></box-border>
      <div class="box-filter">
          <div v-if="type === 'year'" class="box-select">
            <el-select :value="GfcurrentYear" @change="changeGfYear" placeholder="请选择">
              <el-option
                  v-for="(year,index) in yearList"
                  :key="index"
                  :value="year"
                  :label="year + '年'"
              >
              </el-option>
            </el-select>
          </div>

          <div v-if="type === 'month'" class="box-select">
            <el-select :value="GfcurrentMonth" @change="changeGfMonth" placeholder="请选择">
              <el-option
                  v-for="(month,index) in monthList"
                  :key="index"
                  :value="month"
                  :label="month + '月'"
              >
              </el-option>
            </el-select>
          </div>
        </div>

         <div style="height: 100%;background: rgba(10, 27, 46, .51);">
            <div id="chartGufd" class="chart"></div>
         </div>
    </div>
  </div>
</template>

<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";
export default {
  name: "ChartGufd",
  components: {BoxBorder,  BoxHeader},
  data() {
    return {
      chart: null,
      GfcurrentYear: "",
      yearList: ["2023","2024","2025","2026"],
      monthList: ["12","11","10","9","8","7","6","5", "4", "3", "2", "1"],
      dayList:[],
      GfcurrentMonth: "",
      Gfcategory: [],
      statisticsType:"oil",
      Gfmax: 0,
      GfdataList: {
        use: [],
        storage: [],
        fd:[]
      },
      count:0,
      type:"beforeTen",
      currentYear:"",
      currentMonth:"",
      currentDay:"",
      data:[],
      category:[],
      sectionData:[]
    };
  },
  mounted() {
    this.$nextTick(() => {
        this.GfcurrentYear =  new Date().getFullYear() +"";
        this.getPhotovoData();
    });
  },
  methods: {
    refreshChart() {
      this.$nextTick(() => {
        if (!this.chart) {
          this.chart = this.$echarts.init(document.getElementById("chartGufd"));
        }
        this.chart.resize();
        this.renderGfChart();
      });
    },
    changeGfYear(year) {
      this.GfcurrentYear = year;
      this.getGfData();
    },
    changeGfMonth(month) {
      this.GfcurrentMonth = month;
      this.getGfData();
    },
    changeGfType(type){
      this.type = type;
      let time = new Date();
      this.GfcurrentMonth = (time.getMonth() + 1) + "";
      this.getGfData();

      this.$nextTick(() => this.chart && this.chart.resize());
    },
    getGfData() {
      if (!this.chart) return;

      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)"
      });

      //年视图
      if (this.type === "year") {
        this.$api.getData_Photovoltaic(this.GfcurrentYear)
            .then(res => {
              this.disposeGfData(res.data);
            });
      }

      //月视图
      if (this.type === "month") {
        this.$api.getData_Photovoltaic_month(this.GfcurrentYear,this.GfcurrentMonth)
            .then(res => {
              this.disposeGfData(res.data);
            });
      }

      if (this.type === "beforeTen") {
        this.$api.getData_Photovoltaic_tenDaysAgo()
            .then(res => {
              this.disposeGfData(res.data);
            });
      }
    },
    disposeGfData(sourceData) {
      if(this.type === "year"){
        this.Gfcategory = sourceData.map(item => item.rq + "月");
      }else if(this.type === "month"){
        this.Gfcategory = sourceData.map(item => item.rq + "日");
      }else{
        const result = sourceData.map(item => {
          let day = item.rq.split('-')[2]; // 例如 "13"
          if(day.startsWith("0")){
            day = day.replace("0","");
          }
          return `${day}日`; // 转换为 "13日"
        });
        this.Gfcategory = result;
      }
      this.GfdataList.use = sourceData.map(item => item.gf);
      this.GfdataList.storage = sourceData.map(item => item.cd);
      this.GfdataList.fd = sourceData.map(item => item.fd);
      this.renderGfChart();
    },
    renderGfChart() {
      this.chart.hideLoading();
      const colorArr = [
        {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: "rgba(246,110,103,1)" // 0% 处的颜色
            }, {
              offset: 1, color: "rgba(246,110,103,0.2)" // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },
        {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: "rgba(96,234,75,1)" // 0% 处的颜色
            }, {
              offset: 1, color: "rgba(119,234,157,0.35)" // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        },
        {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [{
              offset: 0, color: "rgba(75,214,234,1)" // 0% 处的颜色
            }, {
              offset: 1, color: "rgba(84, 237, 255,0.2)" // 100% 处的颜色
            }],
            global: false // 缺省为 false
          }
        }
      ];

      let options = {
        legend: {
          show: true,
          top: 20,
          itemWidth: 40,
          itemGap: 80,
          itemStyle:{
            opacity:0
          },
          lineStyle: {
            width: 10
          },
          textStyle: {
            fontFamily: "Alibaba PuHuiTi",
            padding: 10,
            height: 26,
            fontSize: 24,
            color: "rgba(211, 238, 254, 1)"

          }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          confine: true,
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: "<div class='name' style='font-size: 30px;font-weight: 500'>{b0}</div><div class='title' style='margin-top: 20px;'>{a0}</div><div class='value'>{c0}<span class='unit'>kwh</span></div> <div class='title' style='margin-top: 10px;'>{a1}</div><div class='value'>{c1}<span class='unit'>kwh</span></div>",
          textStyle: {
            fontSize: 30
          }
        },
        grid: {
          top: 80,
          bottom: 40,
          left: 30,
          right: 50,
          containLabel: true
        },
        xAxis: {
          type: "category",
          data: this.Gfcategory,
          axisLabel: {
            show: true,
            margin: 25,
            interval: 0,
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          name: "kwh",
          nameLocation: "end",
          nameGap: 30,
          nameTextStyle: {
            fontSize: 26,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)"
          },
          splitNumber: 3,
          axisLabel: {
            show: true,
            margin: 25,
            fontSize: 26,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          }
        },
        dataZoom: [{
          type: "inside",
          show: true,
          startValue: 0,
          endValue: 11,
          rangeMode: ["value"],
          zoomLock: true
        }],
        series: [
          {
            name: "光伏",
            data: this.GfdataList.use,
            type: "line",
            showSymbol: false,
            symbolSize: 0,
            symbol: "none",
            lineStyle: {
              width: 0,
              color: "rgba(246,110,103,1)",
            },
            smooth: false,
            areaStyle: colorArr[0]
          },
          {
            name: "放电量",
            data: this.GfdataList.fd,
            type: "line",
            showSymbol: false,
            symbolSize: 0,
            symbol: "none",
            lineStyle: {
              width: 0,
              color: "rgb(96,234,75)",
            },
            smooth: false,
            areaStyle: colorArr[1]
          }
        ]
      };

      this.chart.setOption(options);
    },
    getPhotovoData(){
      this.chart = this.$echarts.init(document.getElementById("chartGufd"));
      this.getGfData();
    },
  }
};
</script>
<style scoped lang="scss">
::v-deep .box-header {   /* 你的 BoxHeader 根元素类名按实际改 */
  position: relative;
  z-index: 9999;
}
.page-header{
  z-index: 1;
}

.box-header-tab {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  z-index: 9999;


  .tab-item {
    width: 166px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: url("../../assets/image/bg_tab_un.png");
    color: rgba(161, 197, 234, .7);
    font-size: 30px;
    line-height: 72px;
    font-family: "screen", serif;
    margin-right: 25px;
    cursor: pointer;

    &.active {
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, .56), 0 0 1em rgba(82, 163, 255, .56);
      background: url("../../assets/image/bg_tab_on.png");
    }
  }
}

.box-filter {
  display: flex;
  justify-content: space-between;
  padding: 0 0 0 30px;;
  box-sizing: border-box;
}

.box-count {
  height: 50px;
  line-height: 45px;

  .count-name {
    font-size: 28px;
    color: rgb(181, 228, 255);
  }

  .count-value {
    font-size: 32px;
    color: rgb(86, 237, 255);
    font-family: "screen", serif;
  }

  .count-unit {
    font-size: 22px;
    color: rgba(181, 228, 255, 0.6);
    margin-left: 10px;
  }
}

.box-select {
  width: 200px;

  ::v-deep.el-input {
    font-size: 30px;

    .el-input__inner {
      height: 60px;
      line-height: 60px;
    }
  }
}
</style>
